export default "__VITE_ASSET__BSzdLjAr__"